import React from "react";
import { Link } from "react-router-dom";

function EmptyState({
  title = "Nothing found",
  message = "Try removing a filter or exploring the full collection.",
  actionLabel = "View all pieces",
  actionTo = "/shop",
  onAction,
}) {
  const actionClassName = "empty-state__action";

  return (
    <section className="empty-state" aria-labelledby="empty-state-title">
      <p className="empty-state__eyebrow">No results</p>
      <h2 className="empty-state__title" id="empty-state-title">
        {title}
      </h2>
      <p className="empty-state__message">{message}</p>
      {onAction ? (
        <button className={actionClassName} type="button" onClick={onAction}>
          {actionLabel}
        </button>
      ) : (
        <Link className={actionClassName} to={actionTo}>
          {actionLabel}
        </Link>
      )}
    </section>
  );
}

export default EmptyState;
